import React from "react";

export default function JiniEndPoint() {
  return "https://bookingjini.info/jiniassist_api";
}
